import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { TextField } from '@material-ui/core'
import styled from 'styled-components'

const StyledAutocomplete = styled(Autocomplete)`
    .MuiInputBase-root {
        padding: 0 !important;
        display: flex;
        align-items: center;
        font-size: 1rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition:
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
        height: calc(1.5em + 1rem + 2px);

        &:hover {
            border-color: #ced4da;
        }

        &.Mui-focused {
            border-color: #80bdff;
            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
        }

        fieldset {
            border: none;
        }
    }

    .MuiAutocomplete-input {
        padding: 0 0.75rem !important;
        height: auto;
        box-sizing: border-box;
        align-self: center;
    }

    .MuiAutocomplete-endAdornment {
        top: 50%;
        transform: translateY(-50%);
    }
`

const SearchableSelect = ({ options, value, onChange, placeholder, getOptionLabel, className, ...props }) => {
    return (
        <StyledAutocomplete
            options={options}
            value={options.find((option) => String(option.id) === String(value)) || null}
            className={className}
            onChange={(event, newValue) => {
                onChange({
                    target: {
                        name: props.name,
                        value: newValue ? newValue.id : '',
                    },
                })
            }}
            getOptionLabel={getOptionLabel || ((option) => option.name || '')}
            getOptionSelected={(option, value) => String(option.id) === String(value.id)}
            renderInput={(params) => <TextField {...params} placeholder={placeholder} variant="outlined" fullWidth size="small" />}
            {...props}
        />
    )
}

export default SearchableSelect
